import React, { useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';

import ValidIcon from '@mui/icons-material/Check';
import InvalidIcon from '@mui/icons-material/Clear';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';


import ResetIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/PlayCircleFilled';

import withLoader from 'components/Shared/withLoader';
import { green, red } from '@mui/material/colors';

import { ArborescenceGestionNiveaux } from 'constants.js';

const TextFieldWithLoader = withLoader(TextField);

const useStyles = makeStyles((theme) => ({
    reset: {
        color: red[500],
    },
    check: {
        color: green[500],
    },
    adornment: {
        marginTop: '0px',
    },
}));


function SousFamilleImportArea({ onImport }) {

    const classes = useStyles();

    const [value, setValue] = useState('');

    const [sousFamilles, setSousFamilles] = useState([]);

    const [nokCodes, setNokCodes] = useState([]);

    const [loading, setLoading] = useState(false);


    const fetchData = async (codes) => {

        if (codes.length > 0) {

            setLoading(true);

            await axios.post(`api/arborescence-gestion/check`, { codes: codes, niveau: ArborescenceGestionNiveaux.SousFamille })
                .then(function (response) {

                    let sousFamilles = response.data;

                    let okSousFamilles = sousFamilles.filter(famille => famille.libelle);

                    let noKCodes = sousFamilles.filter(famille => !famille.libelle).map(famille => famille.code);

                    setSousFamilles(okSousFamilles);
                    setNokCodes(noKCodes);


                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    setLoading(false);
                    setValue('');
                });
        }
    };


    const handleClickValid = () => {

        console.log("handleClickValid value", value);

        let codes = value
            .replace(/\D/gm, " ")
            .replace(/\s+/gm, " ")
            .trim()
            .split(' ')
            .map(ref => ref.padStart(6, '0'));

        fetchData(codes);

    };



    return (
        <div style={{ width: '100%' }}>


            {(loading || (sousFamilles.length === 0 && nokCodes.length === 0)) && (
                <TextFieldWithLoader
                    isLoading={loading}
                    label={"Sous-Familles"}
                    multiline
                    style={{ width: '100%' }}
                    aria-label="minimum height"
                    variant="filled"
                    InputLabelProps={{ shrink: true }}
                    placeholder="Veuillez entre votre liste de codes sous-familles :
                    500000
                    500001
                    500002
                    500003
                    500100
                    …"
                    onChange={e => setValue(e.target.value)}
                    value={value}
                    InputProps={{
                        endAdornment: value && (
                            <InputAdornment className={classes.adornment}>

                                <IconButton onClick={() => setValue('')} className={classes.reset} size="large"><ResetIcon /></IconButton>
                                <IconButton onClick={handleClickValid} className={classes.check} size="large"><CheckIcon /></IconButton>

                            </InputAdornment>),
                    }}
                />
            )}




            {!loading && (sousFamilles.length > 0 || nokCodes.length > 0) && (

                <React.Fragment>
                    {sousFamilles.map((sousFamille, index) => {
                        return (<p key={index}><ValidIcon style={{ color: green[500] }} /> {sousFamille.code} - {sousFamille.libelle}</p>)
                    })}

                    {nokCodes.map((nokCode, index) => { return (<p key={index}><InvalidIcon style={{ color: red[500] }} /> {nokCode}</p>) })}



                    <Button onClick={() => { setValue(''); setSousFamilles([]); setNokCodes([]); }}>Annuler</Button>
                    <Button disabled={sousFamilles.length === 0} onClick={() => { onImport(sousFamilles); setValue(''); setSousFamilles([]); setNokCodes([]); }}>Ajouter</Button>

                </React.Fragment>

            )}


        </div>
    );




}

SousFamilleImportArea.propTypes = {
    onImport: PropTypes.func.isRequired,
};

SousFamilleImportArea.defaultProps = {
}


export default SousFamilleImportArea;